// The icon set the app registers with `MatIconRegistry`.
//
// Pure data, no imports: `src/app/interfaces.ts` imports `SvgIconId` to type the icon field on
// model interfaces, and the model layer must not gain an edge to Angular Material. The
// registration that needs `MatIconRegistry` lives in `register-app-icons.ts`.
//
// Keep sorted and unique — `scripts/sync-phosphor-icons.js` reads this list to decide which
// files belong in `src/assets/icons/phosphor/regular/`, and `phosphor-icons.spec.ts` enforces
// both properties.

/** Regular-weight glyphs from `@phosphor-icons/core`, copied verbatim by the sync script. */
export const PHOSPHOR_ICON_NAMES = [
  'arrow-counter-clockwise',
  'arrow-left',
  'arrow-right',
  'arrow-u-up-left',
  'arrows-clockwise',
  'camera',
  'camera-slash',
  'caret-down',
  'caret-left',
  'caret-right',
  'caret-up',
  'chat-dots',
  'check',
  'check-circle',
  'circuitry',
  'clock',
  'clock-countdown',
  'clock-counter-clockwise',
  'credit-card',
  'currency-circle-dollar',
  'device-mobile',
  'door-open',
  'dots-three-circle',
  'envelope',
  'eye',
  'eye-slash',
  'file-text',
  'floppy-disk',
  'gavel',
  'hand-heart',
  'handshake',
  'headset',
  'house',
  'images',
  'info',
  'lightbulb',
  'lightning',
  'link-break',
  'list',
  'package',
  'paperclip',
  'pencil-simple',
  'phone',
  'phone-call',
  'plus',
  'plus-circle',
  'prohibit',
  'question',
  'scan',
  'seal-warning',
  'shield-check',
  'shopping-bag',
  'shopping-cart-simple',
  'sign-in',
  'sign-out',
  'ticket',
  'trash',
  'user',
  'user-plus',
  'users',
  'wallet',
  'warning',
  'warning-circle',
  'x-circle',
  'x-square',
] as const;

export type PhosphorIconName = (typeof PHOSPHOR_ICON_NAMES)[number];

/**
 * Glyphs drawn for REITE. On Phosphor's 256 grid so they sit correctly beside the rest, but not
 * part of the set — they live at `assets/icons/<name>.svg`, outside `phosphor/regular/`, which is
 * what keeps the sync script from treating them as drift and deleting them.
 */
export const REITE_ICON_NAMES = ['mini-store'] as const;

export type ReiteIconName = (typeof REITE_ICON_NAMES)[number];

/**
 * Every name `<mat-icon svgIcon="…">` may be given. The prefix says where the glyph came from,
 * so a REITE-custom icon can never be mistaken for one the sync script maintains.
 */
export type SvgIconId = `ph-regular-${PhosphorIconName}` | `reite-${ReiteIconName}`;
